import {ModuleProto} from "../../module-proto";
import {ModuleType} from "../../types";
import {SettingsMenuTopCategory} from "../../settings-module";
import {SettingsParentSection} from "../../../../app/settings/const";

const debug = false

export class ReplyTaskByEmailModule extends ModuleProto {

    constructor(moduleConfig:any) {
        super(ModuleType.REPLY_TASK_BY_EMAIL, moduleConfig);

        this.name                       = "Reply Task by Email"
        this.description                = "Let users post updates to a task by replying to its notification email. Each reply is added to the task as a new message. Turn it off if replies to task notifications should not be posted back to GoodDay."
        this.svgIcon                    = "isvg-reply-by-email"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.INTEGRATIONS
        this.typeLabel                  = "Integrations"
        this.settingsUrl                = "settings/integrations/reply-task-by-email"
        this.parentSection              = SettingsParentSection.INTEGRATIONS

        this.canDisable                 = true

        debug && console.log("ReplyTaskByEmailModule", "_isEnabled", this._isEnabled)
    }
}
